export default {
    stat: {
        all: []
    }
}
